import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/globals.css';

const appTree = (
    <HelmetProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
        </BrowserRouter>
    </HelmetProvider>
);

const rootEl = document.getElementById('root')!;
const app = import.meta.env.DEV ? appTree : <React.StrictMode>{appTree}</React.StrictMode>;

// If the root already has prerendered content, hydrate instead of re-rendering
// from scratch. This preserves the static HTML for SEO while React takes over.
if (rootEl.innerHTML.trim().length > 0) {
    ReactDOM.hydrateRoot(rootEl, app);
} else {
    ReactDOM.createRoot(rootEl).render(app);
}
